import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ApButtonComponent } from '@ap/button';
import { ApCardComponent } from '@ap/card';
import { ApContentModule } from '@ap/content';
import { ApColComponent, ApRowComponent, ApXsDirective } from '@ap/grid';
import { ApHeaderComponent } from '@ap/header';
import { ApIllustrationComponent } from '@ap/illustration';
import { ApNotificationComponent } from '@ap/notification';
import { ApTabsModule } from '@ap/tabs';

import { BackgroundThemeModule } from './background-theme/background-theme.module';
import { MijnLoginTemplateComponent } from './mijn-login-template.component';

/**
 * @name MijnLoginTemplateModule
 * @ngdoc module
 */
@NgModule({
    imports: [
        ApButtonComponent,
        ApContentModule,
        ApCardComponent,
        ApXsDirective,
        ApColComponent,
        ApHeaderComponent,
        ApRowComponent,
        ApIllustrationComponent,
        ApNotificationComponent,
        ApTabsModule,
        BackgroundThemeModule,
        CommonModule
    ],
    exports: [MijnLoginTemplateComponent],
    declarations: [MijnLoginTemplateComponent]
})
export class MijnLoginTemplateModule {}
